export default __webpack_public_path__ + "images/0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f.png";